import React from 'react';

const LowesForecast = () => {
	return (
		<div>
			<h1>LowesForecast</h1>
		</div>
	);
};

export default LowesForecast;
